const getFuelLogs = (params) => {
  return { apiUrl: `/api/fuellogs?${params}`, method: "GET" };
};

const getDeliveryAgentsList = (params) => {
  return { apiUrl: `/api/fleetdeliveryagentbookings?${params}`, method: "GET" };
};

const getPickupAgentsList = (params) => {
  return { apiUrl: `/api/fleetpickupagentbookings?${params}`, method: "GET" };
};

const getHubName = (id) => {
  return { apiUrl: `/api/hubs?limit=100&cityId=${id}`, method: "GET" };
};

const getCityName = (id) => {
  return { apiUrl: `/api/cities/indexify`, method: "GET" };
};

const imageUpload = () => {
  return { apiUrl: `/fileapi/upload`, method: "POST" };
};

const vehiclesDetails = (hubId) => {
  return {
    apiUrl: `/api/vehicles?limit=500&offset=0&hubId=${hubId}`,
    method: "GET",
  };
};

const getAllVehiclesDetails = (hubId) => {
  return {
    apiUrl: `/api/vehicles?limit=1000`,
    method: "GET",
  };
};

const getVehicle = (vehicleId) => {
  return { apiUrl: `/api/vehicles/${vehicleId}`, method: "GET" };
};

const getVehicleByLicensePlate = (vehicleRegistration) => {
  return {
    apiUrl: `/api/vehicles?licensePlate=${vehicleRegistration}`,
    method: "GET",
  };
};

const getBlockVehicleDetails = (vehicleId) => {
  return { apiUrl: `/api/blockedvehicles/${vehicleId}`, method: "GET" };
};

const getBlockedVehicleExtensionDetails = (vehicleId) => {
  return {
    apiUrl: `/api/blockvehicleextns?blockId=${vehicleId}`,
    method: "GET",
  };
};

const getBlockVehicleHistory = (vehicleId) => {
  return {
    apiUrl: `/api/blockedvehiclehistories?blockId=${vehicleId}`,
    method: "GET",
  };
};

const getSystemUserList = (isSystemUserId) => {
  return {
    apiUrl: `/api/users?limit=1000&isSystemUser=${isSystemUserId}`,
    method: "GET",
  };
};

const getVehicleIssueData = (vehicleId) => {
  return {
    apiUrl: `/api/vehicleissues?limit=100&offset=0&status=523&vehicleId=${vehicleId}`,
    method: "GET",
  };
};

const getIssueDetail = (issueId) => {
  return {
    apiUrl: `/api/vehicleissues/${issueId}`,
    method: "GET",
  };
};

const getVendorsList = () => {
  return {
    apiUrl: `/api/vendors?limit=1000&page=0`,
    method: "GET",
  };
};

const getPartAndAccessoriesList = () => {
  return {
    apiUrl: `/api/partandaccessories/indexify`,
    method: "GET",
  };
};

const getIssuePartDetails = (issueId) => {
  return {
    apiUrl: `/api/issuepartdetails?issueId=${issueId}`,
    method: "GET",
  };
};

const getVehicleManufacturer = () => {
  return {
    apiUrl: `/api/vehicle-make/indexify`,
    method: "GET",
  };
};

const getVehicleManufacturerModel = (manufacturerId) => {
  return {
    apiUrl: `/api/vehicle-model/indexify?vehicleManufacturer=${manufacturerId}`,
    method: "GET",
  };
};

const getVehicleManufacturerModelVariant = (vehicleModalID) => {
  return {
    apiUrl: `/api/vehicle-variants/indexify?vehicleModel=${vehicleModalID}`,
    method: "GET",
  };
};

const getVehicleManufacturerbyId = (vehicleManufacturerbyId) => {
  return {
    apiUrl: `/api/vehicle-make/indexify?vehicleManufacturer=${vehicleManufacturerbyId}`,
    method: "GET",
  };
};

const getIssuesImage = (issueId) => {
  return {
    apiUrl: `/api/issueimages?issueId=${issueId}&limit=1000`,
    method: "GET",
  };
};

const getWorkorderImage = (workorderId) => {
  return {
    apiUrl: `/api/workorderimages?workorderId=${workorderId}&limit=1000`,
    method: "GET",
  };
};

const getIssueGenericTransaction = (issueId) => {
  return {
    apiUrl: `/api/generictransactions?resourceId=${issueId}&resourceType=vehicleIssues`,
    method: "GET",
  };
};

const getVehicleProfileGroups = (groupId) => {
  return {
    apiUrl: `/api/vehiclegroups/${groupId}`,
    method: "GET",
  };
};

const getVehicleGroupsByCity = (cityId) => {
  return {
    apiUrl: `/api/vehiclegroups?limit=1000&cityId=${cityId}`,
    method: "GET",
  };
};

const getVehicleProfileRentalPackages = (groupId) => {
  return {
    apiUrl: `/api/rentalpackages?groupId=${groupId}`,
    method: "GET",
  };
};

const getBikeProfileRentalPackages = (groupId) => {
  return {
    apiUrl: `/api/bikerentalpackages?groupId=${groupId}`,
    method: "GET",
  };
};

const getVehicleProfileDocuments = (vehicleId) => {
  const resourceTypes = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.resourceTypes;
  return {
    apiUrl: `/api/documents?limit=1000&resourceType=${resourceTypes?.inverted?.vehicles}&resourceId=${vehicleId}`,
    method: "GET",
  };
};

const getVehicleProfileImages = (vehicleId) => {
  return {
    apiUrl: `/api/vehicleimages?vehicleId=${vehicleId}&limit=1000`,
    method: "GET",
  };
};

const getVehicleProfileFinancialDetails = (vehicleId) => {
  return {
    apiUrl: `/api/vehiclefindetails?vehicleId=${vehicleId}`,
    method: "GET",
  };
};

const getAffectedBlockings = (vehicleId, form) => {
  return {
    apiUrl: `/api/blockedvehicles/blocklistbyvehicle?vehicleId=${vehicleId}&startDate=${
      form?.startdate + "T" + form?.starttime
    }&endDate=${form?.enddate + "T" + form?.endtime}`,
    method: "GET",
  };
};

const getBookingKPI = (startDate , endDate, city) => {
  return {
    apiUrl: `/api/dashboardreports/booking-dashboard-kpi?startDate=${startDate}&endDate=${endDate}&cityId=${city}`,
    method: "GET",
  };
};

export {
  getBookingKPI,
  getFuelLogs,
  getSystemUserList,
  getBlockVehicleHistory,
  getDeliveryAgentsList,
  getPickupAgentsList,
  getHubName,
  getCityName,
  imageUpload,
  getBlockVehicleDetails,
  getBlockedVehicleExtensionDetails,
  getVehicle,
  getVehicleIssueData,
  getIssueDetail,
  getVehicleByLicensePlate,
  getVendorsList,
  getPartAndAccessoriesList,
  getIssuePartDetails,
  getVehicleManufacturer,
  getVehicleManufacturerbyId,
  getIssuesImage,
  getWorkorderImage,
  getIssueGenericTransaction,
  vehiclesDetails,
  getVehicleProfileGroups,
  getVehicleProfileRentalPackages,
  getVehicleProfileDocuments,
  getVehicleProfileImages,
  getVehicleProfileFinancialDetails,
  getAllVehiclesDetails,
  getVehicleGroupsByCity,
  getVehicleManufacturerModel,
  getVehicleManufacturerModelVariant,
  getAffectedBlockings,
  getBikeProfileRentalPackages
};
